/** Get Summary Dashboard data */
export const DETAIL_DASHBOARD_API_SUCCESS = "DETAIL_DASHBOARD_API_SUCCESS";
export const DETAIL_DASHBOARD_API_FAIL = "DETAIL_DASHBOARD_API_FAIL";
export const GET_DETAIL_DASHBOARD_DATA = "GET_DETAIL_DASHBOARD_DATA";
